export default __webpack_public_path__ + "static/DSC_0176-29646ba5e3b38fa31866ee44df274e24.jpg";